import Cookies from 'js-cookie';
import isExperienceEditor from '@utils/is-experience-editor';

(function (window) {

    var alertBanner = function () {
        var menuStack = [];
        var ui = {};
        var slideCount;
        var isMobile;
        var SHOW_FULL_TEXT = 'collapsed';
        var MEDIA_QUERY = '(max-width: 575px)';
        var mql = window.matchMedia(MEDIA_QUERY);

        function cacheUI() {
            ui.$body = $('body');
            ui.$readMoreBtn = $('.js-alert-banner-readmore-btn');
            ui.$bannerText = '.js-alert-banner-text';
            ui.$removeAlertBtn = $('.js-alertbanner-alert__banner__close-btn');
            ui.$alertBarMsg = $('.alert__banner__item__text__message');
        }

        function bindEvents() {
            ui.$readMoreBtn.on('click', showAllText);
            ui.$removeAlertBtn.on('click', removeAlertBanner);
        }

        function initModalAlert() {
            // let ssItem = sessionStorage.getItem('modal-alert');

            if ($('#ModalAlert').length) {
                let modalAlertId = $('#ModalAlert').attr('data-id');

                if(!getCookie(modalAlertId)){
                    showAlertModal();
                    setCookie(modalAlertId, 'active', 1);
                }
 
            }

        }

        function initAlertBanner(e) {
         /*    if (sessionStorage.getItem('vcaalertbanner') === 'active' || getCookie('vcaalertbanner') == 'active') {
                $('.js-alert-banner').remove();
            } */

            // check each alert and remove if cookie found
            $('.js-alertbanner-alert__banner__close-btn').each(function (index, element) {
                let alertId = $(element).attr('data-id');
                let hospitalName = $(element).attr('data-hospital');

                if (getCookie(alertId) == 'active') {
                    $(element).closest('.alert__banner__item').remove();
                }

            });

            var alertSlider = $('.js-alert__banner__slider').each(function (index, element) {
                $(this).addClass('alert-banner--slider-' + index);
                if (!isExperienceEditor) {
                    $('.alert-banner--slider-' + index).slick({
                        autoplay: true,
                        autoplaySpeed: 5000,
                        adaptiveHeight: true,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        rows: 0,
                        dots: false
                    });
                }

                $('.alert-banner--slider-' + index).on('afterChange', function (event, slick, currentSlide, nextSlide) {
                    var current = ++currentSlide;
                    //check the length of total items in .slide container
                    //if that number is the same with the number of the last slider
                    //Then pause the slider
                    if (slideCount === current) {
                        //this should do the same thing -> slider.slickPause();
                        $('.alert-banner--slider-' + index).slick('slickPause');
                    };
                });
            });

            slideCount = alertSlider.slick('getSlick').slideCount;
        }

        function setCookie(name, value, days) {
            let expires = "";
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }

        function getCookie(name) {
            let nameEQ = name + "=";
            let ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function showAllText(e) {
            let $currentSlide = $(e.target).closest('.alert__banner__item');
            let fullMsg = $($currentSlide).find('.alert__banner__alert-msg-copy').html();
            let fullMsgContainer = $('#ReadMoreModal').find('.modal-message');
            $(fullMsgContainer).empty().html(fullMsg);
            $('#ReadMoreModal').modal('show');
        }

        function removeAlertBanner(e) {
            let $banner = $(e.target).closest('.js-alert-banner');
            let alertId = $(e.currentTarget).attr('data-id');

            //add to cookies
            setCookie(alertId, 'active', 1);

            $('.alert-banner--slider-0').slick('slickRemove', $('.slick-slide').index($('.slick-current')));

            let $bannerContainer = $('.alert__banner__slider').find('.alert__banner__item');
            let $bannerAlertsLength = $bannerContainer.length;

            if ($bannerAlertsLength == 0) {

                //    setCookie('vcaalertbanner', 'active', 1);

                $banner.slideUp("slow", function () {
                    $banner.remove();
                });
            }

        }

        function checkAlertSession() {
            // if (sessionStorage.getItem('vcaalertbanner') === 'active') {
            //     $('.js-alert-banner').remove();
            // } else {
            $('.js-alert-banner').addClass('active');
            // }
        };


        function showAlertModal() {
            $('#ModalAlert').modal('show');
        }

        function resizeAlertMsgs() {
            ui.$alertBarMsg.each((idx, alertMsg) => {
                let stringMsg = $(alertMsg).text().toString().trim();
                let HTMLMsg = $(alertMsg).html();
                let formattedMsg = '';

                if (mql.matches) {
                    if (stringMsg.length > 72) {
                        formattedMsg = truncateHTML(HTMLMsg, 72);
                        $(alertMsg).html(`${formattedMsg}...`);
                        $(alertMsg).append(`<button class="alert__banner__slider__read-more js-alert-banner-readmore-btn">Read more</button>`);
                    }
                } else {
                    if (stringMsg.length > 158) {
                        formattedMsg = truncateHTML(HTMLMsg, 158);
                        $(alertMsg).html(`${formattedMsg}...`);
                        $(alertMsg).append(`<button class="alert__banner__slider__read-more js-alert-banner-readmore-btn">Read more</button>`);
                    }
                }
            });
            $('.js-alert-banner-readmore-btn').on('click', showAllText);
        }

        function truncateHTML(HTMLMsg, limit) {
            let holdCounter = false;
            let truncatedHTML = '';
            let html = HTMLMsg;
            let index = 0;

            for (index = 0; index < html.length; index++) {
                if (!limit) {
                    break;
                }
                if (html[index] == '<') {
                    holdCounter = true;
                }
                if (!holdCounter) {
                    limit--;
                }
                if (html[index] == '>') {
                    holdCounter = false;
                }
                truncatedHTML += html[index];
            }
            //truncatedHTML = correctHTML(truncatedHTML);

            return truncatedHTML;
        }

        function correctHTML(html) {
            let container = document.createElement('div');
            container.innerHTML = html

            return container.innerHTML;
        }

        function init() {
            cacheUI();
            bindEvents();
            resizeAlertMsgs();
            initModalAlert();
            initAlertBanner();
            checkAlertSession();
        }

        return {
            init: init
        };
    };

    var alert = alertBanner();
    alert.init();
})(window);